import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CampanhaFilterModule } from '../../filter';
import { CampanhaVisualizacaoModule } from '../../visualizacao';
import { AreaSelectModule } from '../../../../areas/components/select/area-select.module';
import { CampanhaTableModule } from '../table';
import { CampanhaPipelineModule } from '../pipeline'
import { CampanhaDashboardModule } from '../dashboard';

import { CampanhaViewEmbeddedComponent } from './campanha-view-embedded.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaFilterModule,
        CampanhaVisualizacaoModule,
        AreaSelectModule,
        CampanhaTableModule,
        CampanhaPipelineModule,
        CampanhaDashboardModule
    ],
    declarations: [
        CampanhaViewEmbeddedComponent
    ],
    exports: [
        CampanhaViewEmbeddedComponent
    ]
})
export class CampanhaViewEmbeddedModule { }
